import { CardContainer, PhoneNumbersForm, RevisionHistorySection } from '@/_containers';
import { ViewLogSection } from '@/_containers/view-logs';

import { usePageContext } from '../../shared';

export function ProfileRightSection() {
  const { id, edit, isReverting, revisionHistory } = usePageContext();

  return (
    <>
      <CardContainer right>
        <PhoneNumbersForm isEditable={edit[0]} isSortable />
      </CardContainer>
      <CardContainer right bodyClassName="3xl:pr-0 pr-0">
        <RevisionHistorySection id={`${id}`} endpoint="competitors" disabled={isReverting} {...revisionHistory} />
      </CardContainer>

      <CardContainer right bodyClassName="3xl:pr-0 pr-0">
        <ViewLogSection id={`${id}`} endpoint="competitors" />
      </CardContainer>
    </>
  );
}
